import styled from 'styled-components';

import { Frame, H1 } from 'components/StyledTemplates/StyledTemplates';
import { Workspace } from 'components/pages/Dashboard/common/CommunityPageStyles';

import useResources from 'hooks/useResources';

import imgLoadingGif from 'assets/loading-gif.gif';

interface LoadingPageProps {
    children?: any;
}

const LoadingPage = (props: LoadingPageProps) => {
    const { children } = props;

    const { t } = useResources();

    return (
        <Wrapper>
            <LegacyLeavesGIF />
            <H1 extra="width: 100%; align-items: center !important; padding: 20px;">
                {children ?? t('common.loading')}
            </H1>
        </Wrapper>
    );
};

const Wrapper = styled(Workspace)`
    flex-direction: column;
    align-items: center !important;
    min-height: calc(100vh - 70px - 120px);

    h1 {
        align-items: center;
        margin-top: 20px;
    }
`;

export const LegacyLeavesGIF = styled(Frame)`
    width: 100px;
    height: 100px;
    background: url('${imgLoadingGif}') no-repeat center center / contain;
`;

export default LoadingPage;
